import React, { createContext, useContext, useState } from 'react';

const PoliciesContext = createContext();

export const usePolicies = () => {
  const context = useContext(PoliciesContext);
  if (!context) {
    throw new Error('usePolicies must be used within a PoliciesProvider');
  }
  return context;
};

export const PoliciesProvider = ({ children }) => {
  const [policies, setPolicies] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileUpload = async (files) => {
    setIsProcessing(true);
    // Simulate NLP processing delay
    setTimeout(() => {
      // Mock data for demonstration
      const mockPolicies = [
        {
          policy_number: 'POL001',
          policyholder_name: 'John Smith',
          insured_name: 'John Smith',
          currency: 'USD',
          premium_frequency: 'monthly',
          premium_amount: 500,
          total_period: 120,
          effective_start_date: '2024-01-01',
          effective_end_date: '2033-12-31'
        },
        {
          policy_number: 'POL002',
          policyholder_name: 'Jane Doe',
          insured_name: 'Jane Doe',
          currency: 'USD',
          premium_frequency: 'yearly',
          premium_amount: 6000,
          total_period: 10,
          effective_start_date: '2024-01-01',
          effective_end_date: '2033-12-31'
        },
        {
          policy_number: 'POL003',
          policyholder_name: 'Yuki Tanaka',
          insured_name: 'Yuki Tanaka',
          currency: 'JPY',
          premium_frequency: 'monthly',
          premium_amount: 75000,
          total_period: 240,
          effective_start_date: '2024-01-01',
          effective_end_date: '2043-12-31'
        },
        {
          policy_number: 'POL004',
          policyholder_name: 'Hans Mueller',
          insured_name: 'Hans Mueller',
          currency: 'EUR',
          premium_frequency: 'monthly',
          premium_amount: 450,
          total_period: 180,
          effective_start_date: '2024-01-01',
          effective_end_date: '2038-12-31'
        },
        {
          policy_number: 'POL005',
          policyholder_name: 'Sarah Johnson',
          insured_name: 'Sarah Johnson',
          currency: 'USD',
          premium_frequency: 'monthly',
          premium_amount: 800,
          total_period: 96,
          effective_start_date: '2024-01-01',
          effective_end_date: '2031-12-31'
        },
        {
          policy_number: 'POL006',
          policyholder_name: 'Carlos Rodriguez',
          insured_name: 'Carlos Rodriguez',
          currency: 'USD',
          premium_frequency: 'yearly',
          premium_amount: 8500,
          total_period: 15,
          effective_start_date: '2024-01-01',
          effective_end_date: '2038-12-31'
        },
        {
          policy_number: 'POL007',
          policyholder_name: 'Aiko Watanabe',
          insured_name: 'Aiko Watanabe',
          currency: 'JPY',
          premium_frequency: 'monthly',
          premium_amount: 60000,
          total_period: 300,
          effective_start_date: '2024-01-01',
          effective_end_date: '2048-12-31'
        },
        {
          policy_number: 'POL008',
          policyholder_name: 'Pierre Dubois',
          insured_name: 'Pierre Dubois',
          currency: 'EUR',
          premium_frequency: 'monthly',
          premium_amount: 600,
          total_period: 120,
          effective_start_date: '2024-01-01',
          effective_end_date: '2033-12-31'
        },
        {
          policy_number: 'POL009',
          policyholder_name: 'Maria Garcia',
          insured_name: 'Maria Garcia',
          currency: 'USD',
          premium_frequency: 'monthly',
          premium_amount: 650,
          total_period: 144,
          effective_start_date: '2024-01-01',
          effective_end_date: '2035-12-31'
        },
        {
          policy_number: 'POL010',
          policyholder_name: 'Kenji Yamamoto',
          insured_name: 'Kenji Yamamoto',
          currency: 'JPY',
          premium_frequency: 'yearly',
          premium_amount: 800000,
          total_period: 20,
          effective_start_date: '2024-01-01',
          effective_end_date: '2043-12-31'
        },
        {
          policy_number: 'POL011',
          policyholder_name: 'Emma Wilson',
          insured_name: 'Emma Wilson',
          currency: 'USD',
          premium_frequency: 'monthly',
          premium_amount: 750,
          total_period: 108,
          effective_start_date: '2024-01-01',
          effective_end_date: '2032-12-31'
        },
        {
          policy_number: 'POL012',
          policyholder_name: 'Lars Andersen',
          insured_name: 'Lars Andersen',
          currency: 'EUR',
          premium_frequency: 'monthly',
          premium_amount: 550,
          total_period: 156,
          effective_start_date: '2024-01-01',
          effective_end_date: '2036-12-31'
        }
      ];
      setPolicies(mockPolicies);
      setIsProcessing(false);
    }, 2000);
  };

  const value = {
    policies,
    setPolicies,
    isProcessing,
    setIsProcessing,
    handleFileUpload
  };

  return (
    <PoliciesContext.Provider value={value}>
      {children}
    </PoliciesContext.Provider>
  );
};
